import { setCoachFeedChaosMode } from '~/utils/coach/feedChaos';

import type { useWebSocketTestMode } from './useWebSocketTestMode';

/**
 * Chaos on the coach feed: durable frames are swallowed at random, so the next one to land is out
 * of order and the client's gap detection fires. The socket is left alone — the point is to prove
 * that a hole in the stream heals through `coachSession(cursor: lastSeq)` and nothing else.
 */
export const useWebSocketChaosMode = (testMode: ReturnType<typeof useWebSocketTestMode>) => {
  if (!testMode) {
    return null;
  }

  const { setMode, isChaosMode } = testMode;

  const start = () => {
    setMode('chaos');
    setCoachFeedChaosMode('chaos');
  };

  const stop = () => {
    setMode('none');
    setCoachFeedChaosMode('none');
  };

  const toggle = () => {
    if (isChaosMode.value) {
      stop();
    }
    else {
      start();
    }
  };

  onUnmounted(() => {
    if (isChaosMode.value) {
      stop();
    }
  });

  return {
    isActive: isChaosMode,
    start,
    stop,
    toggle,
  };
};
